import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import GradientButton from "./GradiantButton";
import { investorApi ,api} from "../../api/api";
import { useDispatch } from "react-redux";
import { loginUser as loginUserAction} from "../../redux/reducers/userReducer";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField, Link,Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";


const Login = () => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(""); // ✅ For inline error
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
  const [password, setPassword] = useState("");
    const [isVerifiedUser, setIsVerifiedUser] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const showMessage = (message, severity = "success") => {
    setSnack({ open: true, message, severity });
  };

  const handleLoginSuccess = (data) => {
    dispatch(
      loginUserAction({
        user: {
          id: data.user.id,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          avatar: data.user.avatar,
          role: data.user.role,
          wallet: data.wallet,
          Email: data.user.Email,
          Mobilenumber: data.user.Mobilenumber,
          isSubscribed: false,
          isKyc: false,
          refferal_code: data.user.refferal_code,
          isVerified: data.user.isVerified,
        },
        token: data.token,
      })
    );

    localStorage.setItem("token", data.token);
    showMessage("Login successful 🎉", "success");
    

     };

  const handleContinue = async () => {
    if (phone.length !== 10) {
      showMessage("Please enter a valid 10-digit mobile number", "warning");
      return;
    }

    try {
      setLoading(true);

      // 🔹 First check user by phone
      const response = await investorApi.checkPhone({ phone });


      setIsVerifiedUser(response.data.isVerified);

      // 🔥 If verified → require password
      if (response.data.isVerified) {
        if (!password) {
          showMessage("Please enter your password", "warning");
          setLoading(false);
          return;
        }


        const loginRes = await api.login({
          userName: phone,
          password,
        });
        console.log(loginRes.data);
        handleLoginSuccess({
          user: loginRes.data,
          token: loginRes.data.token,
          wallet: loginRes.data.wallet,
        });
        setTimeout(() => {
        navigate("/"); // redirect home
      }, 800);
      } else {
        // 🔥 If not verified → OTP login
        const otpRes = await investorApi.VerifyOtp({ phone });
        handleLoginSuccess(otpRes.data);
        setTimeout(() => {
        navigate("/"); // redirect home
      }, 800);
      }

    } catch (error) {
      console.error(error);
      showMessage("Login failed. Try again", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        px: 3,
        pt: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Typography fontWeight={600} fontSize={18}>
          Login/Sign up
        </Typography>
        <IconButton onClick={() => navigate("/")}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* FORM */}
      <Box mt={4}>
        <Typography fontWeight={600} mb={1}>
          Enter phone to continue
        </Typography>

        <TextField
          fullWidth
          placeholder="Enter Mobile Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          inputProps={{ maxLength: 10 }}
          error={Boolean(error)} // ✅ make border red when error
          helperText={error} // ✅ show inline error message
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    pr: 1,
                    borderRight: "1px solid #ddd",
                  }}
                >
                  <Typography fontSize={14}>+91</Typography>
                </Box>
              </InputAdornment>
            ),
          }}
          sx={{
            mt: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
            },
          }}
        />
          {isVerifiedUser && (
          <>
            <TextField
              fullWidth
              required
              label="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                mt:3,
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "&:hover fieldset": {
                    borderColor: "#667eea",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#667eea",
                    borderWidth: 2,
                  },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />


            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mb: 4,
              }}
            >
              <Link
                component={RouterLink}
                to="/forget-password"
                state={{ from: location.state?.from }}
                underline="hover"
                sx={{
                  color: "#667eea",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  "&:hover": {
                    color: "#764ba2",
                  },
                }}
              >
                Forgot Password?
              </Link>
            </Box>
          </>
        )}


        <GradientButton
          onClick={handleContinue}
          text="Sign In"
          width="100%"
          sx={{ mt: 5, py: 1.3 }}
        />
      </Box>

      {/* FOOTER */}
      <Box mt="auto" pb={2}>
        <Typography fontSize={11} color="text.secondary" textAlign="center">
          By continuing, you agree to our <span style={{ fontWeight: 600 }}>Terms & Conditions</span>
        </Typography>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;